<script>
import UTab from '../u-tab/u-tab'

export default {
    name: 'u-step',
    parentName: 'u-steps',
    mixins: [UTab]
}
</script>
